var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"chevron_right","opacity":"0.5"},React.createElement("path",{"id":"Vector","d":"M14.0002 18L15.4102 16.59L10.8302 12L15.4102 7.41L14.0002 6L8.00016 12L14.0002 18Z","fill":"white"})));
}

ChevronLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
